export const articulacao = {
  linhas: [
    {
      key: 'ombro',
      titulo: 'Ombro',
      style: {
        gridRow: '3 / span 6',
        gridColumn: '1',
      },
    },
    {
      colKey: 'movimento',
      key: 'ombro.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '3',
        gridColumn: '2',
      },
    },
    {
      key: 'ombro.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '4',
        gridColumn: '2',
      },
    },
    {
      key: 'ombro.abducao',
      titulo: 'Abdução',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '5',
        gridColumn: '2',
      },
    },
    {
      key: 'ombro.aducao',
      titulo: 'Adução',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '6',
        gridColumn: '2',
      },
    },
    {
      key: 'ombro.rotacaoInterna',
      titulo: 'Rotacao Interna',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '7',
        gridColumn: '2',
      },
    },
    {
      key: 'ombro.rotacaoExterna',
      titulo: 'Rotacao Externa',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '8',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaLombar',
      titulo: 'Coluna Lombar',
      style: {
        gridRow: '9 / span 4',
        gridColumn: '1',
      },
    },
    {
      colKey: 'movimento',
      key: 'colunaLombar.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '9',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaLombar.flexaoLateral',
      titulo: 'Flexão Lateral',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '10',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaLombar.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '11',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaLombar.rotacao',
      titulo: 'Rotação',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '12',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaCervical',
      titulo: 'Coluna Cervical',
      style: {
        gridRow: '13 / span 4',
        gridColumn: '1',
      },
    },
    {
      key: 'colunaCervical.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '13',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaCervical.flexaoLateral',
      titulo: 'Flexão Lateral',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '14',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaCervical.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '15',
        gridColumn: '2',
      },
    },
    {
      key: 'colunaCervical.rotacao',
      titulo: 'Rotação',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '16',
        gridColumn: '2',
      },
    },
    {
      key: 'cotovelo',
      titulo: 'Cotovelo',
      style: {
        gridRow: '17 / span 2',
        gridColumn: '1',
      },
    },
    {
      key: 'cotovelo.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '17',
        gridColumn: '2',
      },
    },
    {
      key: 'cotovelo.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '18',
        gridColumn: '2',
      },
    },
    {
      key: 'antebraco',
      titulo: 'Antebraço',
      style: {
        gridRow: '19 / span 2',
        gridColumn: '1',
      },
    },
    {
      key: 'antebraco.pronacao',
      titulo: 'Pronação',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '19',
        gridColumn: '2',
      },
    },
    {
      key: 'antebraco.supinacao',
      titulo: 'Supinação',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '20',
        gridColumn: '2',
      },
    },
    {
      key: 'punho',
      titulo: 'Punho',
      style: {
        gridRow: '21 / span 4',
        gridColumn: '1',
      },
    },
    {
      key: 'punho.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '21',
        gridColumn: '2',
      },
    },
    {
      key: 'punho.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '22',
        gridColumn: '2',
      },
    },
    {
      key: 'punho.desvioRadial',
      titulo: 'Desvio Radial',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '23',
        gridColumn: '2',
      },
    },
    {
      key: 'punho.desvioUlnar',
      titulo: 'Desvio Ulnar',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '24',
        gridColumn: '2',
      },
    },
    {
      key: 'quadril',
      titulo: 'Quadril',
      style: {
        gridRow: '25 / span 6',
        gridColumn: '1',
      },
    },
    {
      key: 'quadril.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '25',
        gridColumn: '2',
      },
    },
    {
      key: 'quadril.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '26',
        gridColumn: '2',
      },
    },
    {
      key: 'quadril.aducao',
      titulo: 'Adução',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '27',
        gridColumn: '2',
      },
    },
    {
      key: 'quadril.abducao',
      titulo: 'Abdução',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '28',
        gridColumn: '2',
      },
    },
    {
      key: 'quadril.rotacaoInterna',
      titulo: 'Rotação Interna',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '29',
        gridColumn: '2',
      },
    },
    {
      key: 'quadril.rotacaoExterna',
      titulo: 'Rotação Externa',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '30',
        gridColumn: '2',
      },
    },
    {
      key: 'joelho',
      titulo: 'Joelho',
      style: {
        gridRow: '31 / span 2',
        gridColumn: '1',
      },
    },
    {
      key: 'joelho.flexao',
      titulo: 'Flexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '31',
        gridColumn: '2',
      },
    },
    {
      key: 'joelho.extensao',
      titulo: 'Extensão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '32',
        gridColumn: '2',
      },
    },
    {
      key: 'tornozelo',
      titulo: 'Tornozelo',
      style: {
        gridRow: '33 / span 2',
        gridColumn: '1',
      },
    },
    {
      key: 'tornozelo.flexaoPlantar',
      titulo: 'Flexão Plantar',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '33',
        gridColumn: '2',
      },
    },
    {
      key: 'tornozelo.Dorisflexao',
      titulo: 'Dorisflexão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '34',
        gridColumn: '2',
      },
    },
    {
      key: 'pe',
      titulo: 'Pé',
      style: {
        gridRow: '35 / span 2',
        gridColumn: '1',
      },
    },
    {
      key: 'pe.inversao',
      titulo: 'Inversão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '35',
        gridColumn: '2',
      },
    },
    {
      key: 'pe.eversao',
      titulo: 'Eversão',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '36',
        gridColumn: '2',
      },
    },
  ],
  colunas: [
    {
      key: 'articulacao',
      titulo: 'Articulação',
      style: {
        gridRow: '1 / span 2',
        gridColumn: '1',
      },
    },
    {
      key: 'movimento',
      titulo: 'Movimento',
      style: {
        gridRow: '1 / span 2',
        gridColumn: '2',
      },
    },
    {
      key: 'adm',
      titulo: 'ADM',
      style: {
        gridRow: '1',
        gridColumn: '3 / span 2',
      },
    },
    {
      key: 'adm.direito',
      titulo: 'Direito',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '2',
        gridColumn: '3',
      },
    },
    {
      key: 'adm.esquerdo',
      titulo: 'Esquerdo',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '2',
        gridColumn: '4',
      },
    },
    {
      key: 'forcaMuscular',
      titulo: 'Força Muscular',
      style: {
        gridRow: '1',
        gridColumn: '5 / span 2',
      },
    },
    {
      key: 'forcaMuscular.direito',
      titulo: 'Direito',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '2',
        gridColumn: '5',
      },
    },
    {
      key: 'forcaMuscular.esquerdo',
      titulo: 'Esquerdo',
      tipoValor: 'Inteiro',
      style: {
        gridRow: '2',
        gridColumn: '6',
      },
    },
    {
      key: 'referencia',
      titulo: 'Referência',
      style: {
        gridRow: '1 / span 2',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.ombro.flexao',
      titulo: '0 a 170-180º',
      style: {
        gridRow: '3',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.ombro.extensao',
      titulo: '0 a 50-60º',
      style: {
        gridRow: '4',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.ombro.abducao',
      titulo: '0 a 170-180º',
      style: {
        gridRow: '5',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.ombro.aducao',
      titulo: '170-180 a 0º',
      style: {
        gridRow: '6',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.ombro.rotacaoInterna',
      titulo: '0 a 70-80º',
      style: {
        gridRow: '7',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.ombro.rotacaoExterna',
      titulo: '0 a 80-90º',
      style: {
        gridRow: '8',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaLombar.flexao',
      titulo: '0 a 95º',
      style: {
        gridRow: '9',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaLombar.flexaoLateral',
      titulo: '0 a 40º',
      style: {
        gridRow: '10',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaLombar.extensao',
      titulo: '0 a 35º',
      style: {
        gridRow: '11',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaLombar.rotacao',
      titulo: '0 a 35º',
      style: {
        gridRow: '12',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaCervical.flexao',
      titulo: '0 a 65º',
      style: {
        gridRow: '13',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaCervical.flexaoLateral',
      titulo: '0 a 40º',
      style: {
        gridRow: '14',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaCervical.extensao',
      titulo: '0 a 50º',
      style: {
        gridRow: '15',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.colunaCervical.rotacao',
      titulo: '0 a 55º',
      style: {
        gridRow: '16',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.cotovelo.flexao',
      titulo: '0 a 145-155º',
      style: {
        gridRow: '17',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.cotovelo.extensao',
      titulo: '145-155 a 0º',
      style: {
        gridRow: '18',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.antebraco.pronacao',
      titulo: '0 a 80-90º',
      style: {
        gridRow: '19',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.antebraco.supinacao',
      titulo: '0 a 80-90º',
      style: {
        gridRow: '20',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.punho.flexao',
      titulo: '0 a 80-90º',
      style: {
        gridRow: '21',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.punho.extensao',
      titulo: '0 a 75-85º',
      style: {
        gridRow: '22',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.punho.desvioRadial',
      titulo: '0 a 15º',
      style: {
        gridRow: '23',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.punho.desvioUlar',
      titulo: '0 a 45º',
      style: {
        gridRow: '24',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.quadril.flexao',
      titulo: '0 a 120-130º',
      style: {
        gridRow: '25',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.quadril.extensao',
      titulo: '0 a 10-20º',
      style: {
        gridRow: '26',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.quadril.aducao',
      titulo: '0 a 20-30º',
      style: {
        gridRow: '27',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.quadril.abducao',
      titulo: '0 a 45º',
      style: {
        gridRow: '28',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.quadril.rotacaoInterna',
      titulo: '0 a 35-45º',
      style: {
        gridRow: '29',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.quadril.rotacaoExterna',
      titulo: '0 a 40-50º',
      style: {
        gridRow: '30',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.joelho.flexao',
      titulo: '0 a 135-145º',
      style: {
        gridRow: '31',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.joelho.extensao',
      titulo: '135-145 a 0º',
      style: {
        gridRow: '32',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.tornozelo.flexaoPlantar',
      titulo: '0 a 45-55º',
      style: {
        gridRow: '33',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.tornozelo.dorsiflexao',
      titulo: '0 a 15-25º',
      style: {
        gridRow: '34',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.pe.inversao',
      titulo: '0 a 30-40º',
      style: {
        gridRow: '35',
        gridColumn: '7',
      },
    },
    {
      key: 'referencia.pe.eversao',
      titulo: '0 a 15-25º',
      style: {
        gridRow: '36',
        gridColumn: '7',
      },
    },
  ],
}
